import type { NotificationProvider } from "@refinedev/core";
import type { MessageInstance } from "antd/es/message/interface";

export const notificationProvider: (message: MessageInstance) => NotificationProvider = (messageInstance) => ({
  open: ({ message, key, type, description }) => {
    messageInstance.destroy();
    if (type === "progress") {
      messageInstance.loading({ content: message, key });
    } else if (type === "success") {
      if (key?.startsWith("notification")) {
        messageInstance.success({
          content: message || "操作に成功しました。",
          key,
        });
      }
    } else if (type === "error") {
      if (message === "ExpiredCodeException") {
        messageInstance.error({
          content: "確認コードが正しくありません。",
          key,
        });
      } else if (key?.startsWith("notification")) {
        messageInstance.error({
          content: message || "操作に失敗しました。",
          key,
        });
      } else if (key === "login-error") {
        if (message === "Unknown") {
          messageInstance.error({
            content: "ネットワークがタイムアウトしました。",
            key,
          });
        } else {
          messageInstance.error({ content: description, key });
        }
      } else if (key === "timeout" && type === "error") {
        messageInstance.error({
          content: "ネットワークがタイムアウトしました。",
          key,
        });
      } else {
        // debugger;
      }
    }
  },
  close(key) {
    messageInstance.destroy(key);
  },
});
